import axios from 'axios';
import { useQuery } from 'react-query';
import { environment } from '../config/environment';

export const fetchMempoolTx = (txid: string) =>
  axios
    .get(`${environment.apiBase}/mempool?txid=${txid}`)
    .then((res) => res.data);

export const useMempoolTx = (txid: string) => {
  return useQuery(['mempool-tx', txid], () => fetchMempoolTx(txid), {
    retry: false,
    staleTime: 1000 * 60,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export default useMempoolTx;